import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

import Home from '@/pages/Home';
import AnimalDetail from '@/pages/AnimalDetail';
import AdminLogin from '@/pages/admin/Login';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminAnimals from '@/pages/admin/Animals';
import AnimalEditor from '@/pages/admin/AnimalEditor';
import AdminEnquiries from '@/pages/admin/Enquiries';
import AdminSettings from '@/pages/admin/Settings';
import AdminAdmins from '@/pages/admin/Admins';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/animal/:slug" element={<AnimalDetail />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="animals" element={<AdminAnimals />} />
            <Route path="animals/:id" element={<AnimalEditor />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="admins" element={<AdminAdmins />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
